import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { isArray } from "util";
import { get } from "lodash";
import { KlPreferenceSaveFormComponent } from "@app/modules/shared/components/preference-form/kl-preference-save-form.component";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { ConvertIsoDateService } from "@app/modules/shared/services/convert-iso-date.service";
import { UtilService } from "@app/modules/shared/services/util.service";
// import { CompanyDto } from '@dashboard/modules/management/company/model/company.dto';
import { ColumnsDto } from "@app/modules/shared/model/columns.dto";
// import { GridSettings } from '@syncfusion/ej2-pivotview/src/pivotview/model/gridsettings';
import { KlReportComponent } from "@app/modules/shared/components/kl-report/kl-report.component";
import { CompanyDto } from "../../model/company.dto";
import { ReportTypeEnum } from "../../model/report-type.enum";
import { GridSettings } from "@syncfusion/ej2-pivotview/src/pivotview/model/gridsettings";

interface ReportItem {
  label: string;
  key: string;
  value: any;
  accessor?: string;
}

@Component({
  selector: "kl-report-filter2",
  templateUrl: "./kl-report-filter2.component.html",
  styleUrls: ["./kl-report-filter2.component.scss"],
})
export class KlReportFilter2Component implements OnInit {
  @ViewChild("entryModal") private entryModal: any;
  @ViewChild(forwardRef(() => KlPreferenceSaveFormComponent))
  klPreferenceSaveFormComponent: any;
  @ViewChild(forwardRef(() => KlReportComponent)) klReportComponent: any;
  @Output() onApplyReport = new EventEmitter<any>();
  @Output() onSelectReport = new EventEmitter<any>();
  @Output() onClearAll = new EventEmitter<any>();
  @Output() onDeleteFromValues = new EventEmitter<any>();
  @Output() onDeleteSavedReport = new EventEmitter<any>();
  @Output() onCloseReport = new EventEmitter<any>();
  @Output() onCloseAlert = new EventEmitter<any>();
  @Output() onGetReports = new EventEmitter<any>();
  @Output() onReportTypeChange = new EventEmitter<any>();

  // inputs
  @Input() selectedReportFilterValues: Array<ReportItem> = [];
  @Input() designList = [];
  @Input() currentReport: any;
  @Input() parentModule: string;
  @Input() module: string;
  @Input() key: string;
  @Input() type: string;
  @Input() haveAggregate: boolean;
  @Input() saveForm = false;
  @Input() loadReport = false;
  @Input() sourceData: any;
  @Input() alertMessage: string;
  @Input() alertShow: boolean;

  // Loading için
  @Input() loadingText: string;
  @Input() showLoading: boolean;

  @Input() filter: any;
  @Input() report_title: string;
  @Input() url: string;
  @Input() working_period_id: string;
  @Input() company: CompanyDto;
  @Input() columns: Array<ColumnsDto>;
  @Input() pivotColumns: Array<any>;
  @Input() pivotValues: Array<any>;
  @Input() formatString: Array<any>;
  @Input() pivotRows: Array<any>;
  @Input() data: any;
  @Input() report_type: string;
  @Input() parentModuleName = "MATERIAL_MANAGEMENT";
  @Input() moduleName = "MATERIAL_STATUS_REPORT";
  @Input() public gridSettings: GridSettings;

  ReportTypeEnum = ReportTypeEnum;

  reportType: string;
  tableOrPivotType: string;
  showReport = false;
  showFilterPanel = true;
  tableOrPivot = true;

  get = get;

  constructor(
    private translateService: TranslateService,
    private utilService: UtilService,
    private dateConvert: ConvertIsoDateService
  ) {}

  ngOnInit() {
    this.tableOrPivot = true;
    this.tableOrPivotType = ReportTypeEnum.GRID;
    this.reportType = "";
  }

  showLoadingFunc(loadingText: string) {
    this.showLoading = true;
    this.loadingText = loadingText;
  }

  hideLoadingFunc() {
    this.showLoading = false;
    this.loadingText = "";
  }

  isArray(value) {
    return !!Array.isArray(value);
  }

  getTranslated(item, accessor?) {
    let string = "";
    if (isArray(item)) {
      item.forEach((i) => {
        string += this.translateService.instant(get(i, accessor)) + ", ";
      });
      return string;
    } else {
      if (accessor) {
        string += this.translateService.instant(get(item, accessor));
        return string;
      } else {
        string += this.translateService.instant(item);
        return string;
      }
    }
  }

  getReports() {
    this.onGetReports.emit();
  }

  isDate(value) {
    return value instanceof Date;
  }

  convertDate(value) {
    return this.dateConvert.convertDateAndTime(value);
  }

  clearAll() {
    this.onClearAll.emit();
  }

  deleteFromValues(i: number, item: ReportItem) {
    this.onDeleteFromValues.emit({ index: i, item: item });
  }

  deleteSavedReport(i: number, item: any) {
    this.onDeleteSavedReport.emit({ index: i, item: item });
  }

  selectReport(item) {
    this.onSelectReport.emit(item);
  }

  closeReport() {
    this.onCloseReport.emit();
  }

  closeAlert() {
    this.onCloseAlert.emit();
  }

  applyReport() {
    this.reportType = this.tableOrPivot
      ? this.tableOrPivotType
      : this.reportType;
    this.report_type = this.tableOrPivot
      ? this.tableOrPivotType
      : this.reportType;
    this.onApplyReport.emit({ report_type: this.reportType });
  }

  closeEntryModal() {
    this.klPreferenceSaveFormComponent.hide();
  }

  openDesigner(type: string, item?: any) {
    const newWindow: any = window.open("report-designer", "_blank");
    newWindow.currentReport = JSON.stringify(item);
    newWindow.mode = type;
    // newWindow.company = this.utilService.selectedCompany();
    // newWindow.working_period_id = this.utilService.selectedWorkingPeriod().id;
    if (type === "add") {
      newWindow.parentModule = this.parentModule;
      newWindow.module = this.module;
      newWindow.key = this.key;
      newWindow.type = this.type;
      newWindow.sourceData = this.sourceData;
    }
    if (type === "edit") {
      newWindow.currentReport = JSON.stringify(item);
      newWindow.parentModule = this.parentModule;
      newWindow.module = this.module;
      newWindow.key = this.key;
      newWindow.type = this.type;
      newWindow.sourceData = this.sourceData;
    }
    newWindow.blur();
  }

  handleError(error) {
    this.alertMessage = error;
    this.alertShow = true;
  }
}
